import { Injectable } from '@angular/core';
import { CountryService } from './country.service';

@Injectable({ providedIn: 'root' })
export class CountryResolver {
  constructor(private countryService: CountryService) {}

  resolve() {
    return this.countryService.fetchCountries();
  }
}
